<ng-container *ngIf="recommendations?.length == 0">
  <p class="p3-regular text-secondary text-center py-4">
    {{ 'ANALYSES.NORECOMMENDATIONS' | translate }}
  </p>
</ng-container>

<div
  *ngFor="let recommendation of recommendations; let first = first"
  class="d-flex flex-wrap flex-md-nowrap overflow-hidden white-section recomendation-container gp-md-24 gpt-0"
  [class.gmt-24]="!first"
>
  <img [src]="recommendation.image" class="image" />
  <div class="w-100 gp-16 gp-md-0">
    <h6
      [innerHTML]="recommendation.title"
      class="h7-bold gmb-16 d-block d-md-inline-block me-md-2"
    ></h6>
    <div
      *ngIf="propertyExists('increasesRisk', recommendation)"
      class="d-block d-md-inline-block p5-semibold gp-alert gp-alert-danger text-uppercase"
      [ngClass]="
        recommendation.increasesRisk ? 'gp-alert-danger' : 'gp-alert-success'
      "
    >
      {{
        (recommendation.increasesRisk
          ? 'PRS.RECOMMENDATIONS.PREVENTION.INCREASES'
          : 'PRS.RECOMMENDATIONS.PREVENTION.DECREASES'
        ) | translate
      }}
    </div>
    <div *ngIf="!!recommendation.evidenceLevel" class="mb-3">
      <p class="p5-regular text-muted mb-2">
        {{ 'PRS.RECOMMENDATIONS.PREVENTION.EVIDENCE_LEVEL' | translate }}
      </p>
      <app-evidence-level
        [level]="recommendation.evidenceLevel"
      ></app-evidence-level>
    </div>
    <p
      class="p3-regular text-secondary mb-0"
      [innerHTML]="recommendation.description"
    ></p>
  </div>
</div>

<!-- TOPICAL INGREDIENTS -->
<div
  class="d-flex flex-wrap flex-md-nowrap overflow-hidden recomendation-container"
  *ngIf="topicalIngredients?.length"
>
  <img
    [src]="
      'https://content-stg.geneplanet.com/images/Blood/Export_500px/plant_extract_img.jpg'
    "
    class="image"
  />
  <div class="w-100">
    <h6 class="h7-bold mb-3 d-block d-md-inline-block me-md-2">
      {{ 'ANALYSES.TOPICAL_INGREDIENTS' | translate }}
    </h6>
    <div *ngFor="let ingredient of topicalIngredients" class="gmb-16">
      <p
        class="p3-semibold text-secondary mb-0 topical-title"
        [innerHTML]="ingredient.title"
      ></p>
      <p
        class="p3-regular text-secondary mb-0"
        [innerHTML]="ingredient.description"
      ></p>
    </div>
  </div>
</div>

<!-- SUPPLEMENTS -->
<div
  class="d-flex flex-wrap flex-md-nowrap overflow-hidden recomendation-container"
  *ngIf="supplements?.length"
>
  <img
    [src]="'https://content-stg.geneplanet.com/images/DNA/topical_vitC_img.jpg'"
    class="image"
  />
  <div class="w-100">
    <h6 class="h7-bold mb-3 d-block d-md-inline-block me-md-2">
      {{ 'ANALYSES.SUPPLEMENTS' | translate }}
    </h6>
    <div *ngFor="let supplement of supplements" class="gmb-16">
      <p
        class="p3-semibold text-secondary mb-0 topical-title"
        [innerHTML]="supplement.title"
      ></p>
      <p
        class="p3-regular text-secondary mb-0"
        [innerHTML]="supplement.description"
      ></p>
    </div>
  </div>
</div>
